var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 137,
    viewBox: "0 0 74 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_825_232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.849 14.5846C68.0995 14.5846 66.682 13.1661 66.682 11.4176C66.682 9.66808 68.0995 8.24951 69.849 8.24951C71.5985 8.24951 73.0161 9.66808 73.0161 11.4176C73.0161 13.1671 71.5975 14.5847 69.849 14.5846Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.682 31.7557C66.682 33.5048 68.0999 34.9228 69.849 34.9228C71.5982 34.9228 73.0161 33.5048 73.0161 31.7557C73.0161 30.0066 71.5982 28.5886 69.849 28.5886C68.0999 28.5886 66.682 30.0066 66.682 31.7557Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.682 52.0926C66.682 53.8417 68.0999 55.2597 69.849 55.2597C71.5982 55.2597 73.0161 53.8417 73.0161 52.0926C73.0161 50.3435 71.5982 48.9255 69.849 48.9255C68.0999 48.9255 66.682 50.3435 66.682 52.0926Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.682 72.4307C66.682 74.1799 68.0999 75.5978 69.849 75.5978C71.5982 75.5978 73.0161 74.1799 73.0161 72.4307C73.0161 70.6816 71.5982 69.2637 69.849 69.2637C68.0999 69.2637 66.682 70.6816 66.682 72.4307Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.682 92.7686C66.682 94.5178 68.0999 95.9357 69.849 95.9357C71.5982 95.9357 73.0161 94.5178 73.0161 92.7686C73.0161 91.0195 71.5982 89.6016 69.849 89.6016C68.0999 89.6016 66.682 91.0195 66.682 92.7686Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.849 116.274C68.0995 116.274 66.682 114.855 66.682 113.107C66.682 111.357 68.0995 109.94 69.849 109.94C71.5985 109.94 73.0161 111.357 73.0161 113.106C73.0161 114.855 71.5975 116.274 69.849 116.274Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.849 136.612C68.0995 136.612 66.682 135.193 66.682 133.445C66.682 131.695 68.0995 130.277 69.849 130.277C71.5985 130.277 73.0161 131.694 73.0161 133.444C73.0161 135.193 71.5975 136.612 69.849 136.612Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9013 14.5846C49.1518 14.5846 47.7342 13.1661 47.7342 11.4176C47.7342 9.66808 49.1528 8.24951 50.9013 8.24951C52.6508 8.24951 54.0684 9.66808 54.0684 11.4176C54.0693 13.1671 52.6508 14.5846 50.9013 14.5846Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9013 34.9228C49.1518 34.9228 47.7342 33.5042 47.7342 31.7557C47.7342 30.0062 49.1528 28.5886 50.9013 28.5886C52.6508 28.5886 54.0684 30.0072 54.0684 31.7557C54.0693 33.5042 52.6508 34.9228 50.9013 34.9228Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9013 55.2607C49.1518 55.2607 47.7342 53.8421 47.7342 52.0936C47.7342 50.3441 49.1528 48.9265 50.9013 48.9265C52.6508 48.9265 54.0684 50.3451 54.0684 52.0936C54.0693 53.8421 52.6508 55.2607 50.9013 55.2607Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9013 75.5978C49.1518 75.5978 47.7342 74.1802 47.7342 72.4307C47.7342 70.6812 49.1528 69.2637 50.9013 69.2637C52.6508 69.2637 54.0684 70.6822 54.0684 72.4307C54.0693 74.1802 52.6508 75.5978 50.9013 75.5978Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9013 95.9357C49.1518 95.9357 47.7342 94.5171 47.7342 92.7686C47.7342 91.0191 49.1528 89.6016 50.9013 89.6016C52.6508 89.6016 54.0684 91.0201 54.0684 92.7686C54.0693 94.5181 52.6508 95.9357 50.9013 95.9357Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9013 116.274C49.1518 116.274 47.7342 114.855 47.7342 113.107C47.7342 111.357 49.1528 109.94 50.9013 109.94C52.6508 109.94 54.0684 111.358 54.0684 113.107C54.0693 114.855 52.6508 116.274 50.9013 116.274Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9013 136.612C49.1518 136.612 47.7342 135.193 47.7342 133.445C47.7342 131.695 49.1528 130.277 50.9013 130.277C52.6508 130.277 54.0684 131.695 54.0684 133.445C54.0693 135.193 52.6508 136.612 50.9013 136.612Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7104 14.5846C29.9609 14.5846 28.5433 13.1661 28.5433 11.4176C28.5433 9.66808 29.9618 8.24951 31.7104 8.24951C33.4599 8.24951 34.8784 9.66808 34.8784 11.4176C34.8784 13.1671 33.4599 14.5847 31.7104 14.5846Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7104 34.9228C29.9609 34.9228 28.5433 33.5042 28.5433 31.7557C28.5433 30.0062 29.9618 28.5886 31.7104 28.5886C33.4599 28.5886 34.8784 30.0072 34.8784 31.7557C34.8784 33.5042 33.4599 34.9228 31.7104 34.9228Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7104 55.2607C29.9609 55.2607 28.5433 53.8421 28.5433 52.0936C28.5433 50.3441 29.9618 48.9265 31.7104 48.9265C33.4599 48.9265 34.8784 50.3451 34.8784 52.0936C34.8784 53.8421 33.4599 55.2607 31.7104 55.2607Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7104 75.5978C29.9609 75.5978 28.5433 74.1802 28.5433 72.4307C28.5433 70.6812 29.9618 69.2637 31.7104 69.2637C33.4599 69.2637 34.8784 70.6822 34.8784 72.4307C34.8784 74.1802 33.4599 75.5978 31.7104 75.5978Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7104 95.9357C29.9609 95.9357 28.5433 94.5171 28.5433 92.7686C28.5433 91.0191 29.9618 89.6016 31.7104 89.6016C33.4599 89.6016 34.8784 91.0201 34.8784 92.7686C34.8784 94.5181 33.4599 95.9357 31.7104 95.9357Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7104 116.274C29.9609 116.274 28.5433 114.855 28.5433 113.107C28.5433 111.357 29.9618 109.94 31.7104 109.94C33.4599 109.94 34.8784 111.358 34.8784 113.107C34.8784 114.855 33.4599 116.274 31.7104 116.274Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7104 136.612C29.9609 136.612 28.5433 135.193 28.5433 133.445C28.5433 131.695 29.9618 130.277 31.7104 130.277C33.4599 130.277 34.8784 131.695 34.8784 133.445C34.8784 135.193 33.4599 136.612 31.7104 136.612Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7646 14.5846C11.0151 14.5846 9.5975 13.1661 9.5975 11.4176C9.5975 9.66808 11.0161 8.24951 12.7646 8.24951C14.5141 8.24951 15.9316 9.66808 15.9316 11.4176C15.9316 13.1671 14.5141 14.5847 12.7646 14.5846Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5975 31.7557C9.5975 33.5048 11.0154 34.9228 12.7646 34.9228C14.5137 34.9228 15.9316 33.5048 15.9316 31.7557C15.9316 30.0066 14.5137 28.5886 12.7646 28.5886C11.0154 28.5886 9.5975 30.0066 9.5975 31.7557Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5975 52.0926C9.5975 53.8417 11.0154 55.2597 12.7646 55.2597C14.5137 55.2597 15.9316 53.8417 15.9316 52.0926C15.9316 50.3435 14.5137 48.9255 12.7646 48.9255C11.0154 48.9255 9.5975 50.3435 9.5975 52.0926Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5975 72.4307C9.5975 74.1799 11.0154 75.5978 12.7646 75.5978C14.5137 75.5978 15.9316 74.1799 15.9316 72.4307C15.9316 70.6816 14.5137 69.2637 12.7646 69.2637C11.0154 69.2637 9.5975 70.6816 9.5975 72.4307Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5975 92.7686C9.5975 94.5178 11.0154 95.9357 12.7646 95.9357C14.5137 95.9357 15.9316 94.5178 15.9316 92.7686C15.9316 91.0195 14.5137 89.6016 12.7646 89.6016C11.0154 89.6016 9.5975 91.0195 9.5975 92.7686Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7646 116.274C11.0151 116.274 9.5975 114.855 9.5975 113.107C9.5975 111.357 11.0161 109.94 12.7646 109.94C14.5141 109.94 15.9316 111.358 15.9316 113.107C15.9316 114.855 14.5141 116.274 12.7646 116.274Z",
    fill: "#A5E2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7646 136.612C11.0151 136.612 9.5975 135.193 9.5975 133.445C9.5975 131.695 11.0161 130.277 12.7646 130.277C14.5141 130.277 15.9316 131.695 15.9316 133.445C15.9316 135.193 14.5141 136.612 12.7646 136.612Z",
    fill: "#A5E2F6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_825_232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136.438,
    height: 63.4185,
    fill: "white",
    transform: "translate(73.0161 0.173828) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfDots);
export default __webpack_public_path__ + "static/media/halfDots.d9d822e7ebfdde6693d330f2e621154f.svg";
export { ForwardRef as ReactComponent };